import logger from 'src/utils/logger/logger';

class DeviceDetection {
  constructor() {
    logger.debug('[DeviceDetection]', navigator.userAgent.toLowerCase());
    /* Workstation is the default when no device matches */
    this.supported_devices = [
      'stbcoship',
      'hisense',
      'lg',
      'ps4',
      'samsung',
      'sony',
      'tizen',
      'web0s',
      'opera',
      'netrange',
      'seirobotics',
      'zeasn'
    ];
  }

  /**
   * Detect the current device and return the class for it
   * @return {class} the class that inherits AbstractDevice
   * for the current device
   */
  detect() {
    const agent = navigator.userAgent.toLowerCase();
    // console.log('[NetworkStatus] ' + agent);

    const { supported_devices } = this;
    for (let i = 0; i < supported_devices.length; i++) {
      const sdevice = supported_devices[i];
      try {
        const detection = require(`../devices/${sdevice}/detection`).default;
        if (detection(agent)) {
          logger.info('[DeviceDetection] detected', sdevice);
          return require(`../devices/${sdevice}/Device`).default;
        }
      } catch (e) {
        logger.error('[DeviceDetection] ERROR', e);
      }
    }
    logger.info('[DeviceDetection] workstation');
    return require(`../devices/workstation/Device`).default;
  }
}

export default DeviceDetection;



// WEBPACK FOOTER //
// ./src/utils/DeviceDetection.js